import styled from "styled-components";
import { Select } from "antd";

export const StyledSelect = styled(Select)`
  width: 100%;
  background: transparent;

  .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .ant-select-selector:focus,
  .ant-select-selector:active,
  .ant-select-focused .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }

  .ant-select-arrow {
    color: #6898e3;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0px;
  align-items: center;
  border: 0.5px solid #6898e3;
  width: 260px;
  padding: 10px;
  border-radius: 15px;
  font-size: 16px;
  @media only screen and (max-width: 600px) {
    display: block;
    margin: 30px 5px;
  }
`;

export const UserInfoText = styled.p`
  margin: 0px;
  font-size: 16px;
  font-weight: bold;
`;

export const UserInfoEditButton = styled.p`
  color: #365899;
  cursor: pointer;
`;

export const ButtonGroup = styled.div`
  @media only screen and (max-width: 600px) {
    margin: 5px 0px;
  }
`;

export const CancelButton = styled.p`
  padding: 2px 5px;
  margin: 0 3px;
  background-color: red;
  color: white;
  cursor: pointer;
  float: left;
`;

export const SaveButton = styled.p`
  padding: 2px 5px;
  margin: 0 3px;
  background-color: #47e4c2;
  color: white;
  cursor: pointer;
  float: left;
`;
